import React from 'react';
// import { Link } from 'react-router-dom';
import Button from '../components/ui/Button';

// Placeholder images
const aboutHeroImage = 'https://images.unsplash.com/photo-1571902943202-507ec2618e8f?q=80&w=1968&auto=format&fit=crop';

const About = () => {

  // Core values
  const coreValues = [
    {
      title: 'Accessibility',
      description: 'Making quality fitness accessible to everyone regardless of experience level or background.',
      icon: (
        <svg className="w-8 h-8 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
        </svg>
      ),
    },
    {
      title: 'Flexibility',
      description: 'Providing options that fit every lifestyle, schedule, and fitness goal without long-term commitments.',
      icon: (
        <svg className="w-8 h-8 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      ),
    },
    {
      title: 'Quality',
      description: 'Partnering only with top-rated fitness facilities that maintain high standards for equipment, instruction, and cleanliness.',
      icon: (
        <svg className="w-8 h-8 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
        </svg>
      ),
    },
    {
      title: 'Community',
      description: 'Building a supportive fitness community that motivates and inspires members to achieve their goals.',
      icon: (
        <svg className="w-8 h-8 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
        </svg>
      ),
    },
  ];

  return (
    <div>
      {/* Hero Section */}
      <section 
        className="relative bg-cover bg-center py-20 md:py-32" 
        style={{ backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(${aboutHeroImage})` }}
      >
        <div className="container-custom relative z-10 text-white">
          <div className="max-w-2xl">
            <h1 className="text-4xl md:text-5xl font-bold mb-4">
              Our Mission
            </h1>
            <p className="text-xl mb-8 text-gray-200">
              Revolutionizing fitness access in Egypt by connecting people to quality fitness experiences through technology.
            </p>
          </div>
        </div>
      </section>

      {/* Our Story */}
      <section className="py-16 bg-white">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-3xl font-bold mb-6">Our Story</h2>
            <div className="text-gray-600 space-y-4 text-lg">
              <p>
                Sportify was born from a simple observation: despite the growing interest in fitness across Egypt, 
                many people still struggle to maintain consistent workout routines due to limited access to quality fitness facilities,
                inconvenient booking processes, and lack of variety in their fitness routines.
              </p>
              <p>
                Founded in 2023 by a team of fitness enthusiasts and tech innovators, we set out to create a solution 
                that would remove these barriers by offering a comprehensive mobile app that connects users to multiple fitness venues,
                simplifies the booking process, and provides access to a variety of fitness activities.
              </p>
              <p>
                Today, Sportify helps thousands of users across Egypt access quality fitness facilities through
                our convenient platform, flexible booking options, and diverse class offerings. Our mission is to make quality
                fitness accessible to everyone, at multiple venues across Egypt.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Core Values */}
      <section className="py-16 bg-gray-50">
        <div className="container-custom">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold mb-4">Our Core Values</h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              These principles guide everything we do at Sportify, from product development to partner selection.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {coreValues.map((value, index) => (
              <div key={index} className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-blue-50 mb-4">
                  {value.icon}
                </div>
                <h3 className="text-xl font-bold mb-2">{value.title}</h3>
                <p className="text-gray-600">{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>



      {/* Join Us CTA */}
      <section className="py-16 bg-primary text-white">
        <div className="container-custom text-center">
          <h2 className="text-3xl font-bold mb-6">Join the Sportify Community</h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto">
            Experience the future of fitness with flexible options that fit your lifestyle.
            Start your fitness journey with Sportify today.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <Button 
              to="/how-it-works" 
              variant="outline" 
              size="lg" 
              className="border-white text-white hover:bg-white hover:text-primary"
            >
              App Features
            </Button>
            <Button 
              to="/contact" 
              variant="dark" 
              size="lg"
            >
              Contact Us
            </Button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;